/*
 * Carrinho da Artisan.
 *
 * Comportamento vindo do Dawn, reescrito: usa a API de secoes do Shopify
 * para recarregar so a gaveta do carrinho a cada mudanca, em vez de
 * recarregar a pagina.
 *
 * Tres coisas acontecem aqui:
 *   1. mudar a quantidade de um item
 *   2. remover um item
 *   3. adicionar um item vindo de um formulario de produto
 */

const SECAO_CARRINHO = 'artisan-gaveta-carrinho';

function gaveta() {
  return document.getElementById('artisan-gaveta-carrinho');
}

/* Troca o conteudo da gaveta pelo HTML que o Shopify devolveu, sem
   perder o estado de aberta nem o foco. */
function trocarConteudo(html) {
  const antiga = gaveta();
  if (!antiga || !html) return;

  const nova = new DOMParser()
    .parseFromString(html, 'text/html')
    .getElementById('artisan-gaveta-carrinho');
  if (!nova) return;

  const estavaAberta = antiga.hasAttribute('aberta');
  const gatilhoAnterior = antiga.gatilho;

  antiga.replaceWith(nova);

  if (estavaAberta) {
    nova.setAttribute('aberta', '');
    nova.gatilho = gatilhoAnterior;
    document.documentElement.style.overflow = 'hidden';
  }
}

/* Atualiza o numero em cima do icone do carrinho. */
function atualizarContador(quantidade) {
  document.querySelectorAll('[data-contador-carrinho]').forEach((el) => {
    el.textContent = quantidade;
  });
}

function marcarCarregando(ligado) {
  const g = gaveta();
  if (!g) return;
  if (ligado) g.setAttribute('carregando', '');
  else g.removeAttribute('carregando');
}

/* Muda a quantidade de uma linha (0 remove). A linha e identificada pela
   chave (item.key), nao pela posicao: o kit montado pelo Easy Bundle vira
   uma linha so no carrinho, e a posicao nem sempre aponta para ela. Se o
   Shopify recusar o change.js, tenta o update.js; se recusar de novo,
   avisa na gaveta em vez de falhar calado. */
async function mudarLinha(elLinha, quantidade) {
  const chave = elLinha.dataset.chave;
  const raiz = window.Shopify.routes.root;
  const enviar = (rota, corpo) =>
    fetch(`${raiz}cart/${rota}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...corpo, sections: SECAO_CARRINHO }),
    });

  marcarCarregando(true);

  try {
    let resposta = chave
      ? await enviar('change.js', { id: chave, quantity: quantidade })
      : await enviar('change.js', { line: Number(elLinha.dataset.linha), quantity: quantidade });

    if (!resposta.ok && chave) {
      resposta = await enviar('update.js', { updates: { [chave]: quantidade } });
    }

    const dados = await resposta.json();
    if (!resposta.ok) throw new Error(dados.description || dados.message || resposta.status);

    trocarConteudo(dados.sections && dados.sections[SECAO_CARRINHO]);
    if (typeof dados.item_count === 'number') atualizarContador(dados.item_count);
    document.dispatchEvent(new CustomEvent('artisan:carrinho-mudou', { detail: dados }));
  } catch (erro) {
    console.error('Não consegui atualizar o carrinho', erro);
    const aviso = document.createElement('p');
    aviso.className = 'artisan-carrinho__aviso';
    aviso.setAttribute('role', 'alert');
    aviso.textContent = 'Não consegui mudar este item agora. Recarregue a página e tente de novo.';
    elLinha.querySelector('.artisan-carrinho__aviso')?.remove();
    (elLinha.querySelector('div') || elLinha).appendChild(aviso);
  } finally {
    marcarCarregando(false);
  }
}

/* ----------------------------------------------------------------
   Quantidade e remocao, dentro da gaveta
   ---------------------------------------------------------------- */

document.addEventListener('click', (evento) => {
  const passo = evento.target.closest('[data-qtd]');
  if (passo) {
    const campo = passo.parentElement.querySelector('[data-qtd-campo]');
    const atual = parseInt(campo.value, 10) || 0;
    const nova = passo.dataset.qtd === 'mais' ? atual + 1 : Math.max(0, atual - 1);
    mudarLinha(passo.closest('[data-linha]'), nova);
    return;
  }

  const remover = evento.target.closest('[data-remover]');
  if (remover) {
    mudarLinha(remover.closest('[data-linha]'), 0);
  }
});

document.addEventListener('change', (evento) => {
  const campo = evento.target.closest('[data-qtd-campo]');
  if (!campo) return;
  mudarLinha(campo.closest('[data-linha]'), Math.max(0, parseInt(campo.value, 10) || 0));
});

/* ----------------------------------------------------------------
   Adicionar ao carrinho, de qualquer formulario de produto
   ---------------------------------------------------------------- */

document.addEventListener('submit', async (evento) => {
  const form = evento.target.closest('[data-form-produto]');
  if (!form) return;

  evento.preventDefault();

  const botao = form.querySelector('[type="submit"]');
  const erroEl = form.querySelector('[data-erro-produto]');
  const textoOriginal = botao ? botao.textContent : '';

  if (botao) {
    botao.setAttribute('aria-disabled', 'true');
    botao.textContent = 'Adicionando…';
  }
  if (erroEl) erroEl.hidden = true;

  const dados = new FormData(form);
  dados.append('sections', SECAO_CARRINHO);

  try {
    const resposta = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: dados,
    });

    const json = await resposta.json();

    if (json.status) {
      // O Shopify devolve status quando da erro — estoque, por exemplo.
      if (erroEl) {
        erroEl.textContent = json.description || json.message;
        erroEl.hidden = false;
      }
      return;
    }

    trocarConteudo(json.sections && json.sections[SECAO_CARRINHO]);

    const carrinho = await fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());
    atualizarContador(carrinho.item_count);

    const g = gaveta();
    if (g && !g.hasAttribute('aberta')) {
      g.abrir(document.querySelector('[data-abrir="carrinho"]'));
    }
  } catch (erro) {
    console.error('Não consegui adicionar ao carrinho', erro);
    if (erroEl) {
      erroEl.textContent = 'Não consegui adicionar agora. Tente de novo.';
      erroEl.hidden = false;
    }
  } finally {
    if (botao) {
      botao.removeAttribute('aria-disabled');
      botao.textContent = textoOriginal;
    }
  }
});
